// extracted by mini-css-extract-plugin
module.exports = {"MonsterCards":"ChooseMonsterScreen_MonsterCards__1LtaF","Title":"ChooseMonsterScreen_Title__1w--k"};